import { render, staticRenderFns } from "./dialog-table.vue?vue&type=template&id=17dfe7eb&scoped=true&"
import script from "./dialog-table.vue?vue&type=script&lang=js&"
export * from "./dialog-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dfe7eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17dfe7eb')) {
      api.createRecord('17dfe7eb', component.options)
    } else {
      api.reload('17dfe7eb', component.options)
    }
    module.hot.accept("./dialog-table.vue?vue&type=template&id=17dfe7eb&scoped=true&", function () {
      api.rerender('17dfe7eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/modules/dialog-table.vue"
export default component.exports